import { useEffect, useRef } from 'react'
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
} from 'chart.js'

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip)

export function Sparkline({ values, color }: { values: number[]; color: string }) {
  const ref = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const grad = ctx.createLinearGradient(0, 0, 0, 38)
    grad.addColorStop(0, color + '55')
    grad.addColorStop(1, color + '00')

    chartRef.current?.destroy()
    chartRef.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels: values.map((_, i) => String(i)),
        datasets: [
          {
            data: values,
            borderColor: color,
            backgroundColor: grad,
            borderWidth: 2,
            tension: 0.35,
            pointRadius: 0,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        scales: { x: { display: false }, y: { display: false } },
      },
    })

    return () => {
      chartRef.current?.destroy()
      chartRef.current = null
    }
  }, [values, color])

  return <canvas ref={ref} className="h-full w-full" />
}
